module.exports = __webpack_public_path__ + "static/media/motor-black-icon.ea1fea7e.svg";